module.exports = __webpack_public_path__ + "img/11.fa2f5325.png";